import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BackgroundFormService } from 'src/app/services/background-form.service';

@Component({
  selector: 'app-admin-background-forms',
  templateUrl: './admin-background-forms.component.html',
  styleUrls: ['./admin-background-forms.component.scss']
})
export class AdminBackgroundFormsComponent implements OnInit {
  appointment: any
  showbutton:boolean=true
  apptId:any
  dob:any;

  constructor(private bgFormService:BackgroundFormService,private activatedRoute:ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.apptId=params['appointmentId']
    });
    this.bgFormService.viewBackgroundFormDetails(this.apptId).subscribe((res)=>{
      this.appointment=res.data
      this.dob=res.data.backgroundDetails.dateOfBirth;
      console.log("this.dob"+this.dob);

    })
   

  }

  printPage(){
    this
    // (<HTMLInputElement>document.getElementById("print")).innerHTML=""
    window.print()
  }

}
